import React, { Component } from 'react';
import ProductBlock from './productBlock';
import { Link } from 'react-router-dom';
import { getProducts } from '../services/productService';

const categoriesRef = React.createRef();
class FeaturedProducts extends Component {
  state = {
    products: [],
    appear: false,
    appearbtn: false,
  };

  handleScroll = () => {
    var top = window.pageYOffset;

    var introOffset;
    if (window.innerWidth < 450)
      introOffset = categoriesRef.current.offsetTop - window.innerHeight + 320;
    else
      introOffset = categoriesRef.current.offsetTop - window.innerHeight + 380;

    if (top >= introOffset) this.setState({ appear: true });
    else this.setState({ appear: false });

    if (top >= introOffset + 70) this.setState({ appearbtn: true });
    else this.setState({ appearbtn: false });
  };

  async componentDidMount() {
    const { data: products } = await getProducts();
    this.setState({ products });
  }

  componentWillMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    this.setState = (state, callback) => {
      return;
    };
  }

  render() {
    const { products, appear, appearbtn } = this.state;
    let delay = 0;
    return (
      <div ref={categoriesRef} className='featured-products'>
        <div className='overflow-hide'>
          <h2
            className={
              appear
                ? 'featured-products-heading'
                : 'featured-products-heading hide-btn'
            }
          >
            Featured Products
          </h2>
        </div>

        <div className='row'>
          {products.slice(0, 6).map((p) => (
            <div
              key={p._id}
              style={{ transitionDelay: `${delay}s` }}
              className={
                appear
                  ? 'col-6 col-lg-2 col-md-4 col-sm-6 products-display'
                  : 'hide col-6 col-lg-2 col-md-4 col-sm-6 products-display'
              }
            >
              <ProductBlock
                id={p._id}
                key={p._id}
                label={p.label}
                price={p.price}
                imageUrl={p.imageUrl}
                animationDelayz={(delay += 0.06)}
              />
            </div>
          ))}
        </div>
        <div className='overflow-hide'>
          <div className={appearbtn ? 'category-btn' : 'category-btn hide-btn'}>
            <Link to='/products/'>
              <button className='explore-categories'>View All</button>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default FeaturedProducts;
